import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { createEffect } from '@ngrx/effects';
import { exhaustMap, filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { EMPTY } from 'rxjs';
import { selectCurrentLanguage } from '../reducers/translate.reducers';

interface Translation {
  [key: string]: string;
}

@Injectable()
export class LazyModuleLanguageChangeEffects {
  constructor(
    private store: Store,
    private primeNgConfig: PrimeNGConfig,
    private translateService: TranslateService,
  ) {}

  useCurrentLanguage$ = createEffect(
    () =>
      this.store.pipe(
        select(selectCurrentLanguage),
        filter((language) => language != null),
        exhaustMap((currentLanguage) => {
          this.translateService.use(currentLanguage);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  updatePrimeNgCurrentLanguage$ = createEffect(
    () =>
      this.translateService.get('primeNg').pipe(
        exhaustMap((translations: Translation) => {
          this.primeNgConfig.setTranslation(translations);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );
}
